import { combineReducers } from "@reduxjs/toolkit";
// import user from "./user/reducer";
import account from "./account/reducer";

export default combineReducers({
  // user,
  account,

});
